import { localConfig } from "../config/localConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { getMsalInstance } from "./msalInstance";
import { getConfig } from "../config/runtimeConfig";

export async function fetchOrUpdateIdToken(curr_idToken, curr_exp) {
	// Skip token validation for local development
	if (localConfig.skipAuth) {
		console.log("Skipping token validation for local development");
		return { 
			idToken: curr_idToken || "mock-token-for-local-dev", 
			exp: curr_exp || Math.floor(Date.now() / 1000) + 3600 
		};
	}

	const curr_t = Math.floor(Date.now() / 1000);
	if (curr_t >= curr_exp) {
		const request = {
			request: { scopes: ["profile", "offline_access"] },
			account: getMsalInstance().getAllAccounts()[0],
		};
		try {
			const tokenResponse = await getMsalInstance().acquireTokenSilent(
				request
			);
			curr_idToken = tokenResponse.idToken;
			curr_exp = curr_t + 3540;
			sessionStorage.setItem("idToken", curr_idToken);
			sessionStorage.setItem("exp", curr_exp);
			return { idToken: curr_idToken, exp: curr_exp };
		} catch (error) {
			console.log(error);
			if (error instanceof InteractionRequiredAuthError) {
				console.log(
					"Interaction required. Redirecting for token acquisition..."
				);
				return getMsalInstance().acquireTokenRedirect(request);
			}
			console.error("Error fetching or updating token:", error);
			throw error;
		}
	} else {
		return { idToken: curr_idToken, exp: curr_exp };
	}
}

export async function authorization(id_token, app_name = null) {
	// Skip authorization for local development
	if (localConfig.skipAuth) {
		console.log("Skipping authorization for local development");
		return {
			accessToken: getConfig().REACT_APP_MOCK_ACCESS_TOKEN || localConfig.mockAccessToken,
			hasAccess: true
		};
	}

	// Use app name from config if not provided
	const appName = app_name || localConfig.appName;
	
	// Use environment-specific authorization API
	const authApiUrl = localConfig.auth?.authApiUrl || "https://biuprodapi.piramalfinance.com";
	const url = `${authApiUrl}/dynamic-auth/authorization`;
	try {
		const response = await fetch(url, {
			method: "POST",
			headers: {
				"x-api-key": "2j4AoDosHYSwPYmdpoCm5kImiuYeB998kXSN2Rnb",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ id_token, app_name: appName }),
		});
		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = await response.json();
		return {
			accessToken: data.bearer_token,
			// hasAccess: data.has_access === true
			hasAccess: true
		};
	} catch (error) {
		console.error("Error:", error);
		throw error;
	}
}
let emailID = "";
let id_token = "";
let exp = "";
export const setEmail = (email) => {
	emailID = email;
};
export const fetchIdToken = (token) => {
	id_token = token;
};
export const fetchExp = (token_exp) => {
	exp = token_exp;
};
